export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Справочники: Справочник ОИК",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
